import { render } from "./UserBox.vue?vue&type=template&id=939aa874"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__